import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const DividerContainer = styled.div`
  width: 100%;
  height: ${Spacing.SINGLE};
  position: relative;
  margin: ${Spacing.TRIPLE} 0 ${Spacing.DOUBLE};
  color: ${Colors.GRAY_LITE_10};
`;

export const SegmentMargins = styled.div`
  margin-bottom: ${Spacing.TRIPLE};

  ${minScreen(ScreenWidth.MEDIUM)} {
    margin-bottom: ${Spacing.DOUBLE_HALF};
  }

  ${minScreen(ScreenWidth.SMALL)} {
    &:nth-child(2) {
      margin-top: ${Spacing.SINGLE_HALF};
    }
  }
`;
